import { FC } from "react";

import { ClassSessionCategory } from "components/server-types";
import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { useAppSelector } from "store/index";
import { selectActiveClassSessionCategory } from "store/selectors";
import { useAv } from "utils/av";

export const UnsupportedDeviceBanner: FC = () => {
  const classSessionCategory = useAppSelector(selectActiveClassSessionCategory);
  const { isAvSupportedInBrowser, isAvActiveInAnotherTab } = useAv();
  const isMobile = !useIsMdOrLarger();
  if (
    classSessionCategory === ClassSessionCategory.VIRTUAL &&
    !isAvSupportedInBrowser &&
    // We don't want to show the banner if the user is already in another tab with AV active
    !isAvActiveInAnotherTab
  ) {
    return (
      <Banner className="w-full" kind="error">
        {isMobile
          ? t("av.unsupported_device_banner.mobile")
          : t("av.unsupported_device_banner.desktop")}
      </Banner>
    );
  }
  return null;
};
